"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGION = void 0;
var REGION = {
  ASIA: 'ASIA',
  AUSTRALIA: 'AU',
  EU: 'EU',
  US: 'US'
};
exports.REGION = REGION;